// extracted by mini-css-extract-plugin
module.exports = {"group":"Start_group__3Cdp2","links":"Start_links__2B0uH","wrapper":"Start_wrapper__2LzAz","text":"Start_text__3JNKC"};